export const CHECKOUT_URL = "https://pay.kiwify.com.br/B6ySyAX";
export const PRICE = "R$ 47";
export const PRICE_FULL = "R$ 97";
export const PRICE_INSTALLMENT = "5x de R$ 10,84";

export const MEDIA = {
    ebookMockup:
        "https://customer-assets.emergentagent.com/job_conversao-english/artifacts/w7zler1z_Gemini_Generated_Image_fsoevzfsoevzfsoe.png",
    founderPhoto:
        "https://customer-assets.emergentagent.com/job_conversao-english/artifacts/pn3nt4v7_WhatsApp%20Image%202026-05-06%20at%2017.50.42.jpeg",
    travelPhoto:
        "https://customer-assets.emergentagent.com/job_conversao-english/artifacts/22uc5r7s_Screenshot%202023-05-09%20095631.png",
    backgroundTexture:
        "https://static.prod-images.emergentagent.com/jobs/beb5c3b8-5923-4a34-aa4e-e955a45725cf/images/573709fa240be92f2f2b5cf2620fda0bb6633bb1693a0cc64c5ffd5dcee17a28.png",
};
